export default __webpack_public_path__ + "887f525155814eb09faedc2815e2c1e7.png";